'use strict';

module.exports = {
    // One copy per week of the year.
    maxCopyStartDates: 53,
};
